<template>
    <li v-if="this.$store.state.register.form.handling_brand">
        <div class="title"><span>取り扱いブランド</span></div>
        <div class="detail">
            <p><span>{{ this.$store.state.register.form.handling_brand }}</span></p>
        </div>
    </li>
</template>

